import { render, staticRenderFns } from "./SupplierItem.vue?vue&type=template&id=5f432a42&"
import script from "./SupplierItem.vue?vue&type=script&lang=js&"
export * from "./SupplierItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports